import style from './AtmListingPage.css';
import Title from '../../../components/shared/Typography/Title';
import TopUpAppBar from '../../../components/Wallet/TopUpAppBar/TopUpAppBar';
import List from '../../../components/shared/List/List';
import ListItem from '../../../components/shared/List/ListItem';
import useTranslation from '../../../localization/i18n.context';
import BodyText from '../../../components/shared/Typography/BodyText';
import RemoteIcon from '../../../components/shared/RemoteIcon/RemoteIcon';

export default function AtmListingPage() {
  const { t } = useTranslation();
  const banks = JSON.parse(localStorage.getItem('banks-list'));

  return (
    <>
      <TopUpAppBar />

      <div className={style.container}>
        <main className={style.main}>
          <div className={style.head}>
            <Title text={t("Available Bank's ATMs")} />
            <BodyText
              text={t(
                "You can deposit in Fawry POs machine or visit any of the following bank's ATMs",
              )}
              className={style.subtitle}
            />
          </div>

          <List className={style.content} data-testid="banks-list">
            {banks.map((el, index) => (
              <ListItem
                title={el.name}
                key={index}
                icon={
                  el.icon ? (
                    <RemoteIcon width={40} height={40} src={el.icon} />
                  ) : null
                }
                type={ListItem.Type.EXTERNAL}
                size={ListItem.Size.SMALL}
                data-testid="bank"
              />
            ))}
          </List>
        </main>
      </div>
    </>
  );
}
